module.exports = __webpack_public_path__ + "static/media/Shailesh_sir_image.6e46e4a5.svg";